<template>
  <a-modal :title="title" :width="900" :visible="visible" @cancel="handleCancel" v-if="hackReset">
    <template #footer>
      <a-button style="margin-left: 8px" @click="handleCancel">取消</a-button>
      <a-button v-show="isfoot" type="primary" :loading="confirmLoading" @click="handleEdit">修改</a-button>
    </template>
    <a-form :form="form">
      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="图片名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <!-- <a-radio v-model="form.isChecked" :checked="checked">已完成评估工作</a-radio> -->
            <a-input v-model="record.name" placeholder="请输入图片名称" />
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="所属平台" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-radio-group name="radioGroup" v-model="record.platform">
              <a-radio value="2">患者端</a-radio>
              <!-- <a-radio value="2">药师端</a-radio> -->
            </a-radio-group>
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="12">
          <a-form-item label="详细页地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-model="record.url" placeholder="请输入详细页地址" />
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
          <a-form-item label="权重" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
            <a-input-number id="inputNumber" v-model="record.weight" :min="1" :max="10" placeholder="请输入权重" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <a-col :md="24" style="padding-left:9px;padding-right: 165px;">
          <a-form-item label="上传图片" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
            :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
            <img v-if="type == 1" style="width:200px;height:200px" :src="record.photoUrl" alt="">
            <a-upload v-else name="avatar" list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
              :customRequest="fileUpdate" :before-upload="beforeUpload">
              <img v-if="imageUrl" style="width:162px;height:162px" :src="imageUrl" alt="">
              <div v-else>
                <a-icon :type="loading ? 'loading' : 'plus'" />
                <div class="ant-upload-text">
                  Upload
                </div>
              </div>
            </a-upload>

          </a-form-item>
        </a-col>
      </a-row>

    </a-form>
  </a-modal>
</template>

<script>

import { pictureEdit, pictureUpdate } from '@/api/modular/interhospital/picture/pictureMange'
  export default {
    data () {
      return {
        fileList: [],
        imageUrl : '',
        loading: false,
        checked: 0,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 19 }
        },
        form: {},
        visible: false,
        confirmLoading: false,


        title: '',
        isfoot : false,
        parameter : {},
        userDate : '',
        hackReset: true,
        record: {},
        type : '',
      }
    },
    methods: {
      // 初始化方法
      add(record, type) {
        this.confirmLoading = false;
        this.record = {};
        this.imageUrl = record.photoUrl;
        this.type = type;
        this.record = record;
        this.record.platform = this.record.platform + ''
        this.visible = true;
        if (type == 1) {
          this.title = '查看轮播图';
          this.isfoot = false;
        } else {
          this.title = '编辑轮播图';
          this.isfoot = true;
        }
        
      },
      onChangectstamp(date, dateString) {
        this.ctstampDateString = dateString
      },
      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },
      handleCancel () {
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
        })
      },
      
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('建议上传图片大小不超过2MB!');
        }
        return isLt2M;
      },

      // 编辑轮播图
      handleEdit() {
        this.confirmLoading = true;
        let params = {
          id: this.record.id,
          name: this.record.name,
          platform: this.record.platform,
          url: this.record.url,
          weight: this.record.weight,
          photoUrl: this.record.photoUrl,
          orgId: this.record.orgId,
        };
        pictureEdit(params).then(res => {
          this.confirmLoading = false;
          if (res.code == 200) {
            this.form = {};
            this.imageUrl = ''
            this.$message.success('编辑成功');
            this.$emit('ok')
            this.handleCancel()
          } else {
            this.form = {};
            this.imageUrl = ''
            this.$message.error('编辑失败');
            this.handleCancel()
          }
        })
      },

      // 自定义文件上传
      fileUpdate(file) {
        const form = new FormData();
        form.append('file', file.file);
        pictureUpdate(form).then(res => {
          if (res.code == 200) {
            this.record.photoUrl = res.data;
            this.imageUrl = res.data;
          } else {
            this.$message.error('上传图片失败')
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
.viewDetial-tiem{
  margin-bottom: 10px;
}
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
  .viewDetial-title-notes{
    font-weight: 400;
    font-size: 13px;
    color: rgba(127, 127, 127, 0.847058823529412);
    margin-left: 15px;
  }
}
</style>
